import { Injectable } from '@angular/core';
import { BaseErrorHandlerModel, ExtendedServerErrorResponse, LoggingService } from '@app-core';

@Injectable({
    providedIn: 'root',
})
export class NotFoundErrorHandlerService extends BaseErrorHandlerModel {
    override handle(error: ExtendedServerErrorResponse): void {
        LoggingService.log('NotFoundErrorHandlerService::handle:', error);
        this.router.navigate(['/not-found'], { skipLocationChange: true });
    }
}
